<template>
  <v-card
    flat
    class="pa-3 mt-2"
  >
    <v-card-text v-if="!eventsLoaded">
      <v-progress-linear indeterminate></v-progress-linear>
    </v-card-text>

    <v-card-text v-else-if="eventsError">
      <v-alert
        type="warning"
        text
        dense
        class="mb-0"
      >
        {{ eventsError }}
      </v-alert>
    </v-card-text>

    <v-card-text v-else>
      <p class="text--secondary">
        Пуши, которые система отправляет сама, когда что-то случилось. Каждое событие
        сохраняется своей кнопкой; язык с пустыми заголовком и текстом возвращается к тексту
        по умолчанию.
      </p>

      <div
        v-for="group in groups"
        :key="group.code"
        class="mb-6"
      >
        <v-divider class="mb-4"></v-divider>

        <div class="text-subtitle-1 font-weight-medium mb-2">
          {{ group.name }}
        </div>
        <v-alert
          v-if="group.note"
          type="info"
          text
          dense
        >
          {{ group.note }}
        </v-alert>

        <v-expansion-panels multiple>
          <event-setting-panel
            v-for="event in group.events"
            :key="event.code"
            :event="event"
            @test="openTest"
          ></event-setting-panel>
        </v-expansion-panels>
      </div>

      <event-test-dialog
        :show="testShown"
        :event="testedEvent"
        :cancellation="closeTest"
      ></event-test-dialog>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import { eventGroups } from '@/helpers/notifications'
import EventSettingPanel from '@/views/notification-settings/event-setting-panel.vue'
import EventTestDialog from '@/views/notification-settings/event-test-dialog.vue'

export default {
  name: 'EventSettingForm',
  components: { EventSettingPanel, EventTestDialog },
  data: () => ({
    testShown: false,

    testedEvent: null,
  }),
  computed: {
    ...mapState('notificationSettings', ['events', 'eventsLoaded', 'eventsError']),

    groups() {
      const known = eventGroups.map(x => x.code)
      const unknown = this.events
        .map(x => x.group)
        .filter((code, index, codes) => !known.includes(code) && codes.indexOf(code) === index)
        .map(code => ({ code, name: code }))

      return [...eventGroups, ...unknown]
        .map(group => ({ ...group, events: this.events.filter(x => x.group === group.code) }))
        .filter(group => group.events.length > 0)
    },
  },
  methods: {
    openTest(event) {
      this.testedEvent = event
      this.testShown = true
    },
    closeTest() {
      this.testShown = false
    },
  },
}
</script>
